import React, { useState, useEffect } from "react";
import axios from "axios";
import Sino from "../../imgs/icons/notificacao.png";
import Sino_Style from "./notificacao.module.css";

export default function Notificacao() {
  const [mostrar, setMostrar] = useState(false);
  const [mensagens, setMensagens] = useState([]);

  useEffect(() => {
    fetchMensagens();
  }, []);

  async function fetchMensagens() {
    try {
      const response = await axios.get("/api/minhas_notificacoes/");
      setMensagens(response.data);
    } catch (error) {
      console.error("Erro ao buscar notificacoes:", error);
    }
  }

  async function excluirNotificacao(id_notificacao) {
    try {
      await axios.post("/api/excluir_notificacao", {
        id_notificacao: id_notificacao
      });
      fetchMensagens();
    } catch (error) {
      console.error("Erro ao excluir notificacao:", error);
    }
  }

  return (
    <div className={Sino_Style.containerSino}>
      <img src={Sino} className={Sino_Style.sinoImg} alt="Sino"
        onClick={() => { setMostrar(!mostrar) }} />
      {mensagens.length > 0 && (
        <span className={Sino_Style.qtnNotificacao}>{mensagens.length}</span>
      )}
      {mostrar && (
        <div className={Sino_Style.caixa}>
          <div className={Sino_Style.mensagemConteiner}>
            {mensagens.length > 0 ? (
              mensagens.map((msg) => (
                <React.Fragment key={msg.id_notificacao_uni}>
                  <p>
                    {msg.mensagem}
                    <img src={require('../../imgs/icons/Excluir.png')} className={Sino_Style.btnExcluir} alt="Excluir" onClick={() => excluirNotificacao(msg.id_notificacao_uni)}/>
                  </p>
                  <hr />
                </React.Fragment>
              ))
            ) : (
              <p>Sem notificações.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}